/**
 * The primary action of a human task: open the LinkedIn chat (copying the
 * draft first), the profile, or the task's link. The copy must succeed BEFORE
 * the chat opens – otherwise the owner pastes an old clipboard into a new
 * chat (the extension's `openChatWithDraft` rule).
 */
import type { HumanTask } from "../api/tasks";
import { copyText } from "./clipboard";
import { primaryAction } from "./workThrough";

export async function openPrimary(task: HumanTask): Promise<{ opened: boolean; copied: boolean; error?: string }> {
  const action = primaryAction(task);
  if (!action.url) return { opened: false, copied: false };
  let copied = false;
  if (action.kind === "open_chat_copy" && task.draft_message) {
    copied = await copyText(task.draft_message);
    if (!copied) {
      return {
        opened: false,
        copied: false,
        error: "Could not copy the draft. Select and copy the text, then open the chat.",
      };
    }
  }
  window.open(action.url, "_blank", "noopener,noreferrer");
  return { opened: true, copied };
}
